import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=21d44d4e&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d44d4e",
  null
  
)

export default component.exports